
<ng-template #accountNullStates>
  <null-state *ngIf="[accountEventStates.emailUnverified, accountEventStates.loading].includes(accountEventState)" [title]="'Hi ' + userService.firstName + '!'"
    [state]="accountEventStates.emailUnverified" [hideButton]="emailSent" [inputData]="emailUnverifiedData"  (buttonClick)="sendVerificationEmail()"></null-state>
  <null-state *ngIf="accountEventState === accountEventStates.noAccounts" [title]="'Hi ' + userService.firstName + '!'"
    [state]="accountEventStates.noAccounts"  (buttonClick)="goToAccounts()"></null-state>
  <null-state *ngIf="accountEventState === accountEventStates.noSubscription" [title]="'Hi ' + userService.firstName + '!'"
    [state]="accountEventStates.noSubscription"  (buttonClick)="goToSubscription()"></null-state>
</ng-template>

<!-- need separate calls to handle loading state between views -->
<ng-container *ngIf="pageType === 'card'" [ngTemplateOutlet]="accountNullStates"></ng-container>
<ng-container *ngIf="pageType === 'list'" [ngTemplateOutlet]="accountNullStates"></ng-container>
<ng-container *ngIf="pageType === 'calendar'" [ngTemplateOutlet]="accountNullStates"></ng-container>

<home-wrapper 
  [viewMode]="pageType" [ngClass]="{ cardList: pageType !== 'calendar' }"
  *ngIf="![accountEventStates.loading, accountEventStates.emailUnverified, accountEventStates.noAccounts, accountEventStates.noSubscription].includes(accountEventState) && 
  { showView: [accountEventStates.normal, accountEventStates.noSubscriptionWithEvents].includes(accountEventState) } as vars">
  <ng-container *ngIf="pageType === 'card'">
    <dashboard-options-panel [showSearch]="true" [filterGroupings]="filterGroupings" class="desktop"></dashboard-options-panel>
    <div class="options-events">
      <dashboard-options-bar class="desktop" [showSortSelect]="true"></dashboard-options-bar>
      <dashboard-options-bar class="mobile" [showSearch]="true" [showFilters]="true" [filterGroupings]="filterGroupings"></dashboard-options-bar>
      <ng-container [ngTemplateOutlet]="eventNullStates"></ng-container>
      <event-view *ngIf="vars.showView" class="card"  [filterGroupings]="filterGroupings" class="scrollable"></event-view>
    </div>
  </ng-container>
  <ng-container *ngIf="pageType === 'list'">
    <dashboard-options-bar [showSearch]="true" [showFilters]="true" [filterGroupings]="filterGroupings"></dashboard-options-bar>
    <ng-container [ngTemplateOutlet]="eventNullStates"></ng-container>
    <event-view *ngIf="vars.showView" class="list" [filterGroupings]="filterGroupings" class="scrollable"></event-view>
  </ng-container>
  <ng-container *ngIf="pageType === 'calendar'">
    <dashboard-options-bar class="desktop" [showFilters]="true" [filterGroupings]="filterGroupings"></dashboard-options-bar>
    <ng-container [ngTemplateOutlet]="eventNullStates"></ng-container>
    <loader-pane-fragment ></loader-pane-fragment>
    <calendar *ngIf="vars.showView" [filterPage]="filterPage"></calendar>
    <event-view *ngIf="vars.showView" [filterGroupings]="filterGroupings" class="scrollable"></event-view>
  </ng-container>
</home-wrapper>

<ng-template #viewTop>

</ng-template>

<ng-template #typeLinks let-mobile="mobile">
  <div class="cat" [ngClass]="{ active: pageType == 'card' }" (click)="savePageType('card')" routerLink="/home/">
    <icon icon="card"></icon><ng-container *ngIf="!mobile">Card</ng-container>
  </div>
  <div class="cat" [ngClass]="{ active: pageType == 'list' }" (click)="savePageType('list')" routerLink="/home/list">
    <icon icon="list"></icon><ng-container *ngIf="!mobile">List</ng-container>
  </div>
  <div class="cat" [ngClass]="{ active: pageType == 'calendar' }" (click)="savePageType('calendar')" routerLink="/home/calendar">
    <icon icon="calendar"></icon><ng-container *ngIf="!mobile">Calendar</ng-container>
  </div>
</ng-template>

<ng-template #eventNullStates>
  <null-state [state]="accountEventStates.noEvents"  (buttonClick)="startNewEvent()" 
    *ngIf="[accountEventStates.noEvents, accountEventStates.fresh, accountEventStates.invitationsOnly].includes(accountEventState)" 
  ></null-state>

  <null-state *ngIf="accountEventState === accountEventStates.hiddenClosedEventsOnly" (buttonClick)="startNewEvent()"
          [state]=" accountEventStates.hiddenClosedEventsOnly" ></null-state>

  <null-state *ngIf="accountEventState === accountEventStates.noSubscriptionWithEventsButClosedAndInvisible"
          [title]="'Hi ' + user.firstName + '!'" (buttonClick)="goToSubscription()"
          [state]="accountEventStates.noSubscriptionWithEventsButClosedAndInvisible"  ></null-state>
  <null-state *ngIf="[accountEventStates.noSubscriptionWithEventsButFilteredOut, accountEventStates.noResults].includes(accountEventState)"  [state]="accountEventStates.noResults"></null-state>
  <null-state *ngIf="accountEventStates.singleSuspended === accountEventState"  [state]="accountEventStates.singleSuspended"  (buttonClick)="goToSuspendedAccount()"></null-state>

</ng-template>
